/**
 * Identidades del dominio.
 *
 * `GAME_RULES.md` (seccion 8, «Definicion e instancia de una carta») separa dos
 * planos que no deben confundirse:
 *
 * - la **definicion**: la identidad de diseno, visible y estable, que comparten
 *   todas las copias de una misma carta;
 * - la **instancia**: una copia concreta de esa definicion durante una partida,
 *   con identidad propia en tiempo de ejecucion.
 *
 * Ambos son cadenas opacas, marcadas para que el compilador impida pasar una
 * donde se espera la otra. La **convencion de formato** de cada identificador
 * sigue pendiente (12.29): aqui solo se fija que son conceptos distintos.
 */
function requireNonBlank(raw, label) {
    if (raw.trim() === '') {
        throw new Error(`Un ${label} no puede estar vacio.`);
    }
    return raw;
}
/**
 * Marca una cadena como identidad de definicion.
 *
 * No valida ningun formato: la convencion sigue pendiente (12.29). Solo
 * rechaza la cadena vacia, que nunca puede identificar nada.
 *
 * @throws {Error} Si `raw` esta vacia o solo contiene espacios.
 */
export function definitionId(raw) {
    return requireNonBlank(raw, 'identificador de definicion');
}
/**
 * Marca una cadena como identidad de instancia.
 *
 * @throws {Error} Si `raw` esta vacia o solo contiene espacios.
 */
export function instanceId(raw) {
    return requireNonBlank(raw, 'identificador de instancia');
}
//# sourceMappingURL=ids.js.map